import { memo, useState, useEffect, useCallback } from 'react';

import { useBroadcastQuery } from '@hooks';

import * as S from './styles';

const ROTATION_INTERVAL = 5000;

const BroadcastBanners = () => {
  const { data } = useBroadcastQuery();
  const [activeIndex, setActiveIndex] = useState(0);

  const banners = data?.banners?.data ?? [];

  const goTo = useCallback((index: number) => setActiveIndex(index), []);

  useEffect(() => {
    if (banners.length <= 1) return undefined;

    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % banners.length);
    }, ROTATION_INTERVAL);

    return () => clearInterval(timer);
  }, [banners.length]);

  if (banners.length === 0) return null;

  return (
    <S.Wrapper>
      <S.Container>
        {banners.map((banner, index) => (
          <S.BannerSlide key={banner.id} $active={index === activeIndex}>
            {banner.url_action ? (
              <S.BannerLink
                href={banner.url_action}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={banner.url_image} alt={`Banner ${index + 1}`} />
              </S.BannerLink>
            ) : (
              <img src={banner.url_image} alt={`Banner ${index + 1}`} />
            )}
          </S.BannerSlide>
        ))}
        {banners.length > 1 && (
          <S.Dots>
            {banners.map((banner, index) => (
              <S.Dot
                key={banner.id}
                $active={index === activeIndex}
                onClick={() => goTo(index)}
                type="button"
              />
            ))}
          </S.Dots>
        )}
      </S.Container>
    </S.Wrapper>
  );
};

export default memo(BroadcastBanners);
